import { apiClient } from './client'

// Helper function to build query parameters
function buildQueryParams(params = {}) {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value)
    }
  })
  const query = searchParams.toString()
  return query ? `?${query}` : ''
}

// ===========================
// ACCOUNTS (master_accounts)
// ===========================
export const accountService = {
  // List all accounts
  list(params = {}) {
    const query = buildQueryParams(params)
    return apiClient.get(`/master/accounts${query}`)
  },

  // Create new account
  create(payload) {
    return apiClient.post('/master/accounts', payload)
  },

  // Get single account details
  get(id) {
    return apiClient.get(`/master/accounts/${id}`)
  },

  // Update account
  update(id, payload) {
    return apiClient.put(`/master/accounts/${id}`, payload)
  },

  // Delete account
  delete(id) {
    return apiClient.delete(`/master/accounts/${id}`)
  },

  // Activate account
  activate(id) {
    return apiClient.put(`/master/accounts/${id}/activate`, {})
  },

  // Non-active account
  nonActive(id) {
    return apiClient.put(`/master/accounts/${id}/non-active`, {})
  },

  // Get account mutations
  getMutations(id, params = {}) {
    const query = buildQueryParams(params)
    return apiClient.get(`/master/accounts/${id}/mutations${query}`)
  },

  // Deposit to account
  deposit(id, payload) {
    return apiClient.post(`/master/accounts/${id}/deposit`, payload)
  },

  // Withdraw from account
  withdraw(id, payload) {
    return apiClient.post(`/master/accounts/${id}/withdraw`, payload)
  },

  // Transfer between accounts
  transfer(payload) {
    return apiClient.post('/master/accounts/transfer', payload)
  },

  // Upload mutation proof file to storage
  uploadProof(file, folder = 'account-mutations') {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('folder', folder)
    return apiClient.postForm('/storage/upload', formData)
  }
}
